import { OrderedMap } from "immutable";

import { EMPTY_MAP } from "app/app.constants";
import { ACTIONS } from "features/planner/planner.constants";
import { ViewMapper } from "features/planner/planner.mappers";

const initialState = EMPTY_MAP;

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.SET_USER_DEFAULT_VIEW_ID:
    case ACTIONS.GET_USER_DEFAULT_VIEW_ID: {
      if (error) return state;

      return state.set("defaultViewId", payload);
    }

    case ACTIONS.UPDATE_VIEW_GROUPS_ORDER:
    case ACTIONS.CREATE_VIEW_GROUPS:
    case ACTIONS.GET_VIEW: {
      if (error) return state;

      return state.set(payload.viewId.toString(), ViewMapper.from(payload));
    }

    case ACTIONS.GET_VIEWS: {
      if (error) return state;

      return state.merge(
        OrderedMap(
          payload.map(view => [view.viewId.toString(), ViewMapper.from(view)]),
        ),
      );
    }

    case ACTIONS.CREATE_VIEW:
    case ACTIONS.UPDATE_VIEW: {
      if (error) return state;

      return state.set(payload.viewId.toString(), ViewMapper.from(payload));
    }

    case ACTIONS.DELETE_VIEW: {
      if (error) return state;

      return state.delete(action.viewId.toString());
    }

    case ACTIONS.ADD_VIEW_COLUMN: {
      const { viewId, viewGroupType } = action;

      return state.updateIn(
        [viewId.toString(), "columnCount", viewGroupType.toString()],
        columnCount => Math.min(columnCount + 1, 30), // Set max columns to 30
      );
    }

    case ACTIONS.DELETE_VIEW_COLUMN: {
      const { viewId, viewGroupType } = action;

      return state.updateIn(
        [viewId.toString(), "columnCount", viewGroupType.toString()],
        columnCount => Math.max(columnCount - 1, 0),
      );
    }

    default:
      return state;
  }
};
